import { Component, Input, OnInit } from '@angular/core';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { ShopByVehicleComponent } from 'src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { environment } from 'src/environments/environment.prod';
import { removeBackslash } from 'src/_lib/pipes/removebackslash.pipe';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { BreadcrumbComponent } from "src/app/templates/breadcrumb/breadcrumb.component";
import { CategoryService } from 'src/_lib/service/category.service';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-category-top-details',
  templateUrl: './category-top-details.component.html',
  styleUrls: ['./category-top-details.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, NgStyle, ShopByVehicleComponent, removeBackslash, BreadcrumbComponent]
})
export class CategoryTopDetailsComponent implements OnInit {
  category_key: number = 0;
  cdnImagePath: string = environment.cdnImagePath;
  imgBasePath: string = environment.imageBasePath;
  isMobileDescriptionExpanded: boolean = false;
  vehicle_name: string = '';
  isSearchByVehicleDisabled: boolean = false;
  chTheme5 = environment.chTheme5;
  chTheme4 = environment.chTheme4;
  @Input() categoryData: any;
  @Input() breadcrumbData: { category_key: number; name: string }[] = [];

  constructor(
    private commonService: CommunicationService,
    private commonPageServie: CommanpageService,
    private categoryService: CategoryService,
    private browser: BrowserService
  ) { }

  ngOnInit(): void {
    const vehicleBtnData = this.commonPageServie.isSearchByVehicleDisabled();
    this.isSearchByVehicleDisabled = vehicleBtnData?.vehicle_search_all_pages;
    if (this.browser.isBrowser) {
      const ls = this.browser.localStorage;
      this.category_key = +(ls?.getItem('selectedcategorykey') || 0);
      this.vehicle_name = ls?.getItem('vehiclename') || "";
    }
    this.commonService.vehiclenameSubject.subscribe(name => {
      this.vehicle_name = name;
    });
  }

  get backgroundImage(): string | null {
    if (!this.categoryData) return null;
    if (this.categoryData.title_image) {
      return `url(${this.cdnImagePath}${this.categoryData.title_image})`;
    }
    const stored = this.categoryService.getStoredAllCategories();
    const mainPhoto = stored?.[0]?.data?.mainCatDetails?.[0]?.main_category_photo;
    if (mainPhoto) {
      return `url(${this.cdnImagePath}${mainPhoto})`;
    }
    return null;
  }

  get hasBannerImage(): boolean {
    return !!this.categoryData?.title_image;
  }

  toggleDescription(): void {
    this.isMobileDescriptionExpanded = !this.isMobileDescriptionExpanded;
  }
}